import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrettifyNumberPipe } from './prettify-number.pipe';
import { PrettifySizePipe } from './prettify-size.pipe';
import { FormatDatePipe } from './format-date.pipe';
import { ConvertUTCToTZPipe } from './convert-utc-to-tz.pipe';
import { ConvertTZToUTCPipe } from './convert-tz-to-utc.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SafeStylePipe } from './safe-style.pipe';
import { BgImagePipe } from './bg-image.pipe';


@NgModule({
  imports: [CommonModule],
  declarations: [
    PrettifyNumberPipe,
    PrettifySizePipe,
    FormatDatePipe,
    ConvertUTCToTZPipe,
    ConvertTZToUTCPipe,
    SafeHtmlPipe,
    SafeStylePipe,
    BgImagePipe,
  ],
  exports: [
    PrettifyNumberPipe,
    PrettifySizePipe,
    FormatDatePipe,
    ConvertUTCToTZPipe,
    ConvertTZToUTCPipe,
    SafeHtmlPipe,
    SafeStylePipe,
    BgImagePipe,
   ],
  providers: [
    PrettifyNumberPipe,
    PrettifySizePipe,
    FormatDatePipe,
    ConvertUTCToTZPipe,
    ConvertTZToUTCPipe,
    SafeHtmlPipe,
    SafeStylePipe,
    BgImagePipe,
  ]
})
export class PipesModule { }
